module.exports = __webpack_public_path__ + "img/achievement_2.ced7ec27.png";